import NextAppBasePaths from '../nextAppBasePaths.mjs';
import { getBasePathFromUrl } from './basePath.mjs';

const isNextAppUrl = (url) => {
  const urlbasePath = getBasePathFromUrl(url);
  return NextAppBasePaths[urlbasePath] !== void 0;
};

export { isNextAppUrl as default };
//# sourceMappingURL=isNextAppUrl.mjs.map
